import { Field } from 'formik'
import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import { CurrencyUnit } from '../../../types'
import styles from './index.module.scss'

type Props = {
  description?: string
  shouldShowRow?: boolean
  hasUnit?: boolean
}

export const CurrencyUnitField: FC<Props> = ({ description = '', shouldShowRow = false, hasUnit = false }) => {
  const { t } = useTranslation(['global'])

  return (
    <div className={shouldShowRow ? styles.containerInRow : styles.containerInColumn}>
      {hasUnit && <span>{t('単位')}：</span>}
      <div className={styles.dropdown}>
        <Field as='select' name='unit'>
          <option value={CurrencyUnit.USD}>{t('米ドル')}</option>
          <option value={CurrencyUnit.JPY}>{t('日本円')}</option>
        </Field>
      </div>
      {description.length > 0 && <p className={styles.notice}>{description}</p>}
    </div>
  )
}
